<template>
  <card>
    <h5
      slot="header"
      class="card-title text-danger font-weight-bold"
    >
      Course Presentations
    </h5>
    <div v-if="rowData.length > 0">
      <div
        v-for="r in rowData"
        :key="r.Id"
      >
        {{ r.Title }}
      </div>
    </div>
    <div
      v-else
    >
      You have no course presentations assigned for this course
    </div>
  </card>
</template>

<script>
import presentationApi from '@/services/api/presentation'
import formatter from '@/services/formatter.js'

export default {
  name: 'HomeStaffPresentationAssignments',
  props: {
    errormsg: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: { padding: '0', height: '20px', 'font-size': '10px', 'text-align': 'center', 'overflow-wrap': 'break-word' },
      rowData: []
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init: function () {
      presentationApi.getAssignments(this.$root.courseKey, this.$root.scouterKey)
        .then(x => {
          for (let i = 0; i < x.length; i++) {
            x[i].PresentationTitle = this.getTitle(x[i])
            x[i].CourseDayTime = this.getCourseDateTime(x[i])
          }
          this.rowData = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    getTitle: function (row) {
      if (row.BackupScouterKey === this.$root.ScouterKey) {
        return row.Title + '**'
      } else {
        return row.Title
      }
    },
    getCourseDateTime: function (row) {
      const dt = new Date(row.CourseStartTime)
      if (isNaN(dt)) {
        return 'Day ' + row.CourseDay
      } else {
        return 'Day ' + row.CourseDay + ' - ' + formatter.formatAsTime(dt)
      }
    },
    formatDate: function (dt) {
      return formatter.formatAsShortDate(dt)
    },
    formatStartTime: function (dt) {
      return formatter.formatAsTime(dt)
    }
  }
}
</script>
